/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';

export default function PdfPreview({ base64Pdf = "", width = '100%', height = '600px', className = '' }) {
  const [pdfUrl, setPdfUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!base64Pdf) {
      setError('No PDF data provided');
      setLoading(false);
      return;
    }

    try {
      // Remove data URL prefix if it exists
      let base64Data = base64Pdf;
      if (base64Pdf.includes('base64,')) {
        base64Data = base64Pdf.split('base64,')[1];
      }

      // Convert base64 to blob
      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      
      setPdfUrl(url);
      setError('');
      setLoading(false);

      // Cleanup function to revoke object URL
      return () => {
        URL.revokeObjectURL(url);
      };
    } catch (err:any) {
      setError('Failed to load PDF: ' + err.message);
      setLoading(false);
    }
  }, [base64Pdf]);

  if (loading) {
    return (
      <div 
        className={`flex items-center justify-center bg-gray-100 ${className}`}
        style={{ width, height }}
      >
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          <p className="mt-2 text-gray-600">Loading PDF...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className={`flex items-center justify-center bg-red-50 border border-red-200 rounded ${className}`}
        style={{ width, height }}
      >
        <div className="text-center p-4">
          <svg className="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-red-900">Error Loading PDF</h3>
          <p className="mt-1 text-sm text-red-700">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={className} style={{ width, height }}>
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        title="PDF Preview"
        className="border rounded"
        style={{ border: '1px solid #e5e7eb' }}
      />
    </div>
  );
}